import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';;
import SingleImageUploader from 'src/components/uploads/image-uploader';
import QuillEditor from 'src/components/quill-editor';
import DropdownPlates from 'src/components/dropdown/dropdown-plates';
import DropdownServices from 'src/components/dropdown/dropdown-services';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import NumberTextField from 'src/components/widgets/number-textfield';
import { initialValues, validationSchema, handleSubmitted } from './formik';
import { mergeNoteFromEditor } from 'src/utils/formatters';

export const DetailForm = ({ item, apiCreate, apiUpdate, apiRemove, ...other }) => {
  const editorRef = useRef();

  const formik = useCustomFormik({
    validationSchema: validationSchema(item),
    onSubmit: async (values) => {
      const mergeValues = mergeNoteFromEditor(values, editorRef, item.note);
      await handleSubmitted(mergeValues, apiCreate, apiUpdate, apiRemove);
    },
  });

  useEffect(() => {
    initialValues(formik, item);
  }, [item]);
  
  return (
    <form onSubmit={formik.handleSubmit} {...other}>
      <Card>
        <CardContent sx={{ px: 1, py: 2 }}>
          <Grid container spacing={3} alignItems="flex-start">
            <Grid xs={12} md={6} container spacing={3}>
              <Grid xs={6} md={6} sm={6}>
                <DropdownPlates
                  formik={formik}
                  onlyRow={true}
                  onRefreshOdo={(val) => {
                    if(!item.atKm){
                      formik.setFieldValue('lastKm', val);
                    }
                  }}
                />
              </Grid>

              <Grid xs={6} md={6} sm={6}>
                <NumberTextField
                  label="Km hiện tại"
                  name="lastKm"
                  formik={formik}
                  inputProps={{ maxLength: 7 }}
                  hintValue={item.atKm}
                />
              </Grid>

              <Grid xs={6} md={6} sm={6}>
                <NumberTextField
                  label="Tổng tiền"
                  name="price"
                  formik={formik}
                  inputProps={{ maxLength: 10 }}
                  hintValue={item.price}
                />
              </Grid>
              
              <Grid xs={6} md={6} sm={6}>
                <DateAndTimePicker
                  label="Ngày bảo dưỡng"
                  name="created"
                  formik={formik}
                  hintValue={item.atTime}
                />
              </Grid>

              <Grid xs={12}>
                <DropdownServices
                  formik={formik}
                  types={[1, 2, 9]}
                />
              </Grid>

              <Grid xs={12}>
                <QuillEditor
                  ref={editorRef}
                  value={item.note}
                />
              </Grid>
            </Grid>
            <Grid xs={12} md={6}>
              <SingleImageUploader formik={formik} label='Hình hóa đơn or Đang bảo dưỡng' />
            </Grid>

            <Grid xs={12} md={6} display="flex"
              sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
            >
              <SubmitButton formik={formik} isRemove={item.id > 0 || false} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
  apiCreate: PropTypes.func,
  apiUpdate: PropTypes.func,
  apiRemove: PropTypes.func,
};
